import IGoogleMapPosition from '~/components/map/types/IGoogleMapPosition';

import IMapEventListenerParams from '../../../types/IMapEventListenerParams';
import IMapSzukajServiceConfig from '../../../types/IMapSzukajServiceConfig';
import { BloczekMarker } from '../../../types/marker/BloczekMarker';
import buildMarkerBounds from '../../shared/buildMarkerBounds';
import fitBounds from '../../shared/fitBounds';
import getMarkerPosition from '../marker/getMarkerPosition';

const getBoundsArr = (serviceConfig: IMapSzukajServiceConfig): google.maps.LatLngBounds => {
  const { markersInnerState } = serviceConfig;

  let positions: IGoogleMapPosition[] = [];

  if (markersInnerState.markers) positions = positions.concat(markersInnerState.markers.map((x) => getMarkerPosition(x)));

  if (markersInnerState.activeMarker) {
    positions = positions.concat([getMarkerPosition(markersInnerState.activeMarker as unknown as BloczekMarker)]);
  }

  return buildMarkerBounds(positions);
};

const addEventListenerToMapFullyLoaded = (params: IMapEventListenerParams<IMapSzukajServiceConfig>) => {
  const { serviceConfig, gmap } = params;
  const { mapRef, config } = serviceConfig;

  google.maps.event.addDomListenerOnce(gmap, 'tilesloaded', () => {
    fitBounds({
      mapRef,
      bounds: getBoundsArr(serviceConfig),
      padding: serviceConfig.mapFitBoundsPadding,
      gmap,
      idleCallback: () => {
        config.isFullyLoaded = true;
      },
    });
  });
};
export default addEventListenerToMapFullyLoaded;
